import {UI} from "../stem-core/ui/UIBase";
import {registerStyle} from "../stem-core/ui/Style";

import {NavBar} from "./nav/NavBar";
import {Header} from "./sections-common/Header";
import {MobileNavbar} from "./nav/MobileNavbar";
import {NavManager} from "./nav/NavManager";
import {Footer} from "./sections-common/Footer";
import {PUBLISHER_URL, READER_URL} from "./Constants";
import {Messages} from "../blinkpay/Messages";
import {LandingPageIndexStyle, LandingPageIndex} from "./LandingPageIndex";
import {EmptySection} from "./sections-user/EmptySection";
import {Team} from "./sections-company/Team";


@registerStyle(LandingPageIndexStyle)
export class CompanyIndex extends LandingPageIndex {
    declare navBar: NavBar;

    // This ids are tied to the Messages so be careful when changing them.
    navManager = new NavManager(
        [
            {
                id: "navPublisher",
                href: PUBLISHER_URL,
                label: Messages.navPublisher,
            },
            {
                id: "navReader",
                href: READER_URL,
                label: Messages.navReader,
            },
        ],
        [
            {
                element: Header,
                id: "company",
                label: Messages.company,
            },
        ]
    );

    onPageEnter() {
        super.onPageEnter();

        this.navBar.refreshFloatingStatus();
    }

    render() {
        const {styleSheet, navManager} = this;

        const description = [
            <p>{Messages.companyHeaderDescription1}</p>,
            <p>{Messages.companyHeaderDescription2}</p>,
            <p>{Messages.companyHeaderDescription3}</p>,
        ];

        const headerOptions: Record<string, any> = {
            id: "company",
            title: Messages.companyHeaderTitle,
            description,
            ctaSection: null,
            hasIllustration: false,
        };

        return [
            <MobileNavbar className={styleSheet.navMobile} navManager={navManager} />,
            <NavBar
                ref="navBar"
                className={styleSheet.nav}
                navManager={navManager}
            />,
            <Header {...headerOptions} />,
            <EmptySection />,
            <Team />,
            <Footer />,
        ];
    }
}
